// Fix for header padding on homepage
(function() {
  // Function to ensure homepage navigation has correct spacing
  function fixHomepageNavigation() {
    if (document.body.classList.contains("template-index")) {
      // Target the element with both classes specifically
      const homepageMenu = document.querySelector(".header__inline-menu.homepage-menu");
      if (homepageMenu) {
        // Force inline styles with !important
        homepageMenu.style.setProperty("padding-left", "0", "important");
        homepageMenu.style.setProperty("margin-left", "8px", "important");
      }

      // Also target any header__inline-menu that might exist on homepage
      const headerMenu = document.querySelector(".header__inline-menu:not(.non-homepage-nav)");
      if (headerMenu && headerMenu !== homepageMenu) {
        headerMenu.style.setProperty("padding-left", "0", "important");
        headerMenu.style.setProperty("margin-left", "8px", "important");
      }
    }
  }

  // Run immediately
  fixHomepageNavigation();

  // Run when DOM is loaded
  document.addEventListener("DOMContentLoaded", fixHomepageNavigation);

  // Run when window loads
  window.addEventListener("load", fixHomepageNavigation);

  // Set up continuous monitoring
  const INTERVAL = 50; // Check every 50ms
  const DURATION = 10000; // Run for 10 seconds after page load
  const startTime = Date.now();

  const intervalId = setInterval(function() {
    fixHomepageNavigation();

    // Stop checking after DURATION ms
    if (Date.now() - startTime > DURATION) {
      clearInterval(intervalId);
    }
  }, INTERVAL);
})();
